import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface FundingStats {
  totalRaised: number;
  backerCount: number;
  goalAmount: number;
  percentFunded: number;
  recentDonations: {
    amount: number;
    date: string;
    name: string;
  }[];
}

export const useFundingStats = () => {
  return useQuery({
    queryKey: ["funding-stats"],
    queryFn: async (): Promise<FundingStats> => {
      const { data, error } = await supabase.functions.invoke("get-funding-stats");
      
      if (error) {
        console.error("Error fetching funding stats:", error);
        throw error;
      }
      
      return data;
    },
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};
